import {Injectable} from '@angular/core';
import {ContextSetter} from 'botato-botengine-browser/botato/botato-botengine/source/Core/Context/ContextSetter.js';
import {ContextItem} from 'botato-botengine-browser/botato/botato-botengine/source/Core/Nlp/ContextItem.js';

@Injectable()
export class BotatoChatLocalContextProviderService implements ContextSetter {
    private context: ContextItem[] = [];

    public async set(sessionId: string, context: ContextItem[]): Promise<void> {
        this.context = context;
        return Promise.resolve();
    }

    public get(): ContextItem[] {
        return this.context;
    }
}
